export const graphCards = ({blocks, budged_saved, clicks}) => {
    return [
        {
            id: 'saved_budget',
            title: 'Saved Budget',
            value: '$' + tableNumber(budged_saved.toFixed(0)),
        },
        {
            id: 'ad_clicks',
            title: 'Ad Clicks',
            value: tableNumber(clicks),
        },
        {
            id: 'blocked_ip',
            title: 'Blocked IPs',
            value: tableNumber(blocks),
        },
    ];
};

export const graphOptions = {
    responsive: true,
    maintainAspectRatio: false,
    hoverMode: 'index',
    stacked: false,
    legend: {
        display: false
    },
    layout: {
        padding: {
            top: 5,
        }
    },
    title: {
        display: false,
    },
    scales: {
        yAxes: [{
            type: 'linear',
            display: false,
            id: 'saved_budget',
        },{
            type: 'linear',
            display: false,
            id: 'ad_clicks',
        },{
            type: 'linear',
            display: false,
            id: 'blocked_ip',
        }],
        xAxes: [{
            gridLines: {
                display: true,
            },
            ticks: {
                autoSkipPadding: 1000000,
                maxRotation: 0,
            }
        }]
    }
};

String.prototype.splice = function(start, delCount, newSubStr) {
    return this.slice(0, start) + newSubStr + this.slice(start + Math.abs(delCount));
};

export const tableNumber = (number) => {
    let str = number.toString();
    if(str.length > 3) return str.splice(str.length - 3, 0, ',');
    else return str;
}

export const tableCurrency = (number) => {
    let str = number.toString();
    if(str.indexOf('.') === -1) str = str + '.00';
    if(str.indexOf('.') === str.length - 2) str = str + '0';
    if(str.length > 6) return '$' + str.splice(str.length - 6, 0, ',');
    else return '$'+str;
}

